import "./App.css";
import Cart from "./components/cart";
import Footer from "./components/footer";
import Header from "./components/header";
import Main from "./components/main";
import { Routes, Route } from "react-router-dom";

function App() {
  return (
    <div className="app-container">
      <Header />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/cart" element={<Cart />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
